var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFavOff = function SvgIcFavOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    fillRule: "evenodd",
    d: "M11.153 1.418a6.7 6.7 0 0 1 3.81-1.411l.3-.007a6.7 6.7 0 0 1 4.776 2.013A6.87 6.87 0 0 1 22 6.828a6.87 6.87 0 0 1-1.96 4.815L12.427 19.4a2 2 0 0 1-2.855 0L1.96 11.643c-2.613-2.663-2.613-6.966 0-9.63a6.673 6.673 0 0 1 8.98-.522l.06.05zm6.031 3.397A2.7 2.7 0 0 0 15.262 4c-.718 0-1.408.292-1.922.815l-.913.93a2 2 0 0 1-2.855 0l-.913-.93a2.675 2.675 0 0 0-3.844 0 2.894 2.894 0 0 0 0 4.026L11 15.144l6.186-6.303c.52-.53.815-1.255.815-2.013s-.295-1.482-.816-2.013",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.199 2.714a5.7 5.7 0 0 1 3.795-1.708L15.262 1c1.526 0 2.988.617 4.064 1.714A5.87 5.87 0 0 1 21 6.828a5.87 5.87 0 0 1-1.674 4.115L11.713 18.7a1 1 0 0 1-1.427 0l-7.612-7.757c-2.232-2.275-2.232-5.955 0-8.229a5.675 5.675 0 0 1 8.127 0l.198.203zm6.7 1.4A3.7 3.7 0 0 0 15.261 3c-.987 0-1.935.4-2.636 1.115l-.912.93a1 1 0 0 1-1.428 0l-.913-.93a3.675 3.675 0 0 0-5.272 0 3.893 3.893 0 0 0 0 5.427L11 16.57l6.9-7.03A3.87 3.87 0 0 0 19 6.829c0-1.019-.397-1.995-1.102-2.713",
    clipRule: "evenodd"
  })));
};
export default SvgIcFavOff;